import Label1 from "../../../../reusableComponents/InputFields/Label1";
import { useAuth } from "../../../../../context/AuthContext";

const GridComponent = () => {
    const { currentUser } = useAuth();
    const firstName = currentUser?.firstName || "";
    const lastName = currentUser?.lastName || "";
    const userName = currentUser?.userName || "";
    const PhoneNumber = currentUser?.phoneNumber || "";
    const email = currentUser?.email || "";

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-x-12 sm:gap-y-6 p-2 sm:p-0">
            {/* First Row */}
            <Label1
                label="First Name"
                placeholder={firstName}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            <Label1
                label="Last Name"
                placeholder={lastName}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />

            {/* Second Row */}
            <Label1
                label="User Name"
                placeholder={userName}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            <Label1
                label="Phone Number"
                placeholder={PhoneNumber}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />

            {/* Third Row */}
            <Label1
                label="Email Address"
                placeholder={email}
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
                className="col-span-1 sm:col-span-2 w-full"
            />
        </div>
    );
};

export default GridComponent;